/* tslint:disable */
/* eslint-disable */
/* @relayHash 4c8c6d78d4047587904458ddb9b843c2 */

import { ConcreteRequest } from "relay-runtime";
export type PortfolioItemsAction = "ADD" | "EDIT" | "REMOVE" | "REORDER" | "%future added value";
export type PortfolioType = "CART" | "HEART" | "%future added value";
export type ModifyPortfolioItemsInput = {
    action: PortfolioItemsAction;
    endPortfolioItemId?: string | null;
    itemsIds?: Array<string | null> | null;
    note?: string | null;
    portfolioItemsIds?: Array<string | null> | null;
    portfolioId?: string | null;
    portfolioType?: PortfolioType | null;
    startPortfolioItemId?: string | null;
    targetPortfolioItemId?: string | null;
    userId: string;
    clientMutationId?: string | null;
};
export type FindingSharedModifyPortfolioItemsMutationVariables = {
    input: ModifyPortfolioItemsInput;
};
export type FindingSharedModifyPortfolioItemsMutationResponse = {
    readonly modifyPortfolioItems: {
        readonly removedItemIds: ReadonlyArray<string | null> | null;
    } | null;
};
export type FindingSharedModifyPortfolioItemsMutation = {
    readonly response: FindingSharedModifyPortfolioItemsMutationResponse;
    readonly variables: FindingSharedModifyPortfolioItemsMutationVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "ModifyPortfolioItemsInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "modifyPortfolioItems",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ModifyPortfolioItemsPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "removedItemIds",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "FindingSharedModifyPortfolioItemsMutation",
    "type": "Mutations",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "FindingSharedModifyPortfolioItemsMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "FindingSharedModifyPortfolioItemsMutation",
    "id": "app-buyer-finding/275.0.0-2020-07-30T17:00:06.168Z/FindingSharedModifyPortfolioItemsMutation",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = '3686fb0a0421042f6ec588dd6f81f363';
export default node;
